<div class="wrapper">
  <div class="emr-page-container">
    <div class="emr-page-title">Select Patient</div>

    <div class="device-connect">
      @if (isDeviceConnected()) {
        <span class="connected-label">&#x2713; Relay device connected</span>
      } @else {
        <p-button [label]="connectDeviceLabel" icon="pi pi-link" (onClick)="connectDevice()"></p-button>
      }
    </div>

    @if (!loaded()) {
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
    } @else {
      @if (patients(); as localPatients) {
      <p-dataView #patientsList [value]="localPatients" filterBy="lastName,firstName">

        <ng-template #header>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input pInputText #filterText type="search" id="filter" placeholder="Search Patients"
              (input)="patientsList.filter(filterText.value, 'contains')" />
          </p-iconfield>
        </ng-template>

        <ng-template let-filteredPatients #list>
          @for (patient of filteredPatients; track patient.id) {
          <div class="patient">
            <span class="patientName">
              {{patient.firstName}} {{patient.lastName}}
            </span>
            <button pButton class="p-button-primary"
              [routerLink]="['../medications', patient.id]">Select</button>
          </div>
          }
        </ng-template>

      </p-dataView>
      }
    }
  </div>
</div>